/**
 * features/common/panelPrimitives.tsx
 * Shared presentational primitives used across multiple panel components.
 */
import React from 'react';
import { DataState } from '../../types';
import { formatAgoShort } from '../../selectors/viewHelpers';

export function ScoreBar({ label, value, color, tooltip }: {
  label: string; value: number; color: string; tooltip?: string;
}) {
  return (
    <div style={{ marginBottom: 8 }}>
      <div className="fsb" style={{ marginBottom: 3 }}>
        <span style={{ fontSize: 13, color: 'var(--t1)' }} title={tooltip}>{label}</span>
        <span className="mono" style={{ fontSize: 13, color }}>{value}</span>
      </div>
      <div className="sbar"><div className="sbar-fill" style={{ width: `${value}%`, background: color }} /></div>
    </div>
  );
}

export function DataSourceBadge({ state }: { state: DataState }) {
  if (!state.candles?.length) return null;
  const src = state.source;
  const colors: Record<string, string> = { api: 'var(--green)', csv: 'var(--blue)', sample: 'var(--t3)' };
  const labels: Record<string, string> = { api: 'LIVE API', csv: 'CSV', sample: 'SAMPLE' };
  const ageStr = formatAgoShort(state.lastUpdated ?? null);
  return (
    <div className="flex gap6">
      <span className="badge" style={{ background: 'var(--bg3)', color: colors[src], border: `1px solid ${colors[src]}40`, fontSize: 10 }}>
        {src === 'api' && <span className="dot-live" style={{ width: 5, height: 5 }} />}
        {labels[src]}
      </span>
      <span style={{ fontSize: 11, color: 'var(--t3)' }}>{ageStr}</span>
    </div>
  );
}
